import { IResponseType } from 'types/ResponseType';

/* --- STATE --- */
export interface LoginPageState {
  processing: boolean;
  error?: string;
  Response?: ResponseLoginUserModel;
  loginBadAttempts: number;
}

export interface LoginUserModel {
  UserName: string | null;
  Password: string | null;
  RememberMe: boolean;
  PageUrl: string;
  Recaptcha: string | null;
}

export interface ResponseLoginUserModel extends IResponseType {
  Result: SignInStatus;
  FailureReasons?: SignInFailureReasons;
  RedirectUrl: string | null;
  Provider: string | null;
}

export interface CodeVerificationModel {
  Provider: string;
  Code: string;
  RememberMe: boolean;
}

export enum SignInStatus {
  Success = 0,
  LockedOut = 1,
  RequiresVerification = 2,
  Failure = 3,
}

export enum SignInFailureReasons {
  Success,
  PasswordExpired,
  MustChangePassword,
}
